import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseAvailabilityModel from "../../models/case-availability";

export default class CaseAvailabilityRepository extends BaseRepository {
  static modelClass = CaseAvailabilityModel;
  modelName = "case-availability";
}
